import styled from 'styled-components'
import { BLACK, GRAYSCALE_600, NEUTRAL_100, NEUTRAL_900 } from '../../styles/colors'
import { INTER } from '../../styles/fonts'

export const Container = (styled.div as any)`
  display: flex;
  flex-direction: column;
  gap: 8px;
`

export const Title = (styled.span as any)`
  font-family: ${INTER.semiBold};
  font-size: 16px;
  color: ${BLACK};
  margin-bottom: 6px;
`

export const RowContainer = (styled.div as any)`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  width: 100%;
`

export const RowLeft = (styled.div as any)`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 6px;
`

export const RowText = (styled.span as any)`
  font-family: ${INTER.regular};
  font-size: 14px;
  color: ${NEUTRAL_900};
`

export const RowValue = (styled.span as any)`
  font-family: ${INTER.medium};
  font-size: 13px;
  color: ${GRAYSCALE_600};
`

export const Divider = (styled.div as any)`
  width: 100%;
  height: 1px;
  background-color: ${NEUTRAL_100};
`
